import { render, staticRenderFns } from "./AdditionalWork.vue?vue&type=template&id=5a55eacc&scoped=true"
import script from "./AdditionalWork.vue?vue&type=script&lang=js"
export * from "./AdditionalWork.vue?vue&type=script&lang=js"
import style0 from "./AdditionalWork.vue?vue&type=style&index=0&id=5a55eacc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a55eacc",
  null
  
)

export default component.exports